import React from 'react';
import { DropdownTooltipText } from '@instinet-analytics/semantic-ui-components';
import gridPreview from './historicalPercentageChangeWidgetGridPreview.png';
import chartPreview from './historicalPercentageChangeWidgetChartPreview.png';

export const historicalPercentageChangeWidgetDescription: DropdownTooltipText =
    {
        body: (
            <>
                <div>
                    The Historical Percentage Change widget provides volume and
                    price historical data for a stock
                </div>
            </>
        ),
        previews: [
            {
                src: gridPreview,
                altText: 'historical-percentage-change-grid-preview',
            },
            {
                src: chartPreview,
                altText: 'historical-percentage-change-chart-preview',
            },
        ],
    };
